export default {
  market: {
    id: 'bo_seller.listings.listing_detail.pricing_insights.table_column.market',
    defaultMessage: 'Market',
  },
  currentBackboxPrice: {
    id: 'bo_seller.listings.listing_detail.pricing_insights.table_column.current_backbox_price',
    defaultMessage: 'Current Backbox Price',
  },
  currentBackboxPriceDescription: {
    id: 'bo_seller.listings.listing_detail.pricing_insights.table_column.current_backbox_price_description',
    defaultMessage:
      "This the current Backbox price for your listing in each market. The price shown does not include Back Market's adjustment fee",
  },
}
